import initReactFastclick from 'react-fastclick';
export default initReactFastclick;
